import { AccommodationBookedForRoommate } from "./BookedFor/BookedForFormTypes";

export enum BookingType {
    "booking_individual" = "TravelBookingList_Select_IndividualBooking",
    "booking_collector" = "TravelBookingList_Select_BookingCollection"
}

export enum SpecificationsIndividual {
    "accommodation_bookings" = "TravelBookingList_Select_AccommodationBooking",
    "train_bookings" = "TravelBookingList_Select_TrainBooking",
    "flight_bookings" = "TravelBookingList_Select_FlightBooking",
    "transfer_bookings" = "TravelBookingList_Select_TransferBooking",
    "travel_info_booking" = "TravelBookingList_Select_TravelInfo",
    "transport_booking" = "TravelBookingList_Select_TransportBooking",
}

export enum SpecificationsCollector {
    "vt_travel_collection" = "TravelBookingList_Select_TravelAccommodationBookingCollection",
    "flight_booking_collection" = "TravelBookingList_Select_FlightBookingCollection",
    "travel_booking_collection" = "TravelBookingList_Select_TravelBookingCollection"
}

export enum BookingIcons {
    "train_bookings" = "fas fa-train",
    "flight_bookings" = "fas fa-plane",
    "travel_info_booking" = "fas fa-map-pin",
    "transfer_bookings" = "fas fa-shuttle-van",
    "transport_booking" = "fas fa-dolly-flatbed",
    "accommodation_bookings" = "fas fa-hotel",
    "flight_booking_collection" = "fas fa-plane",
    "vt_travel_collection" = "fas fa-hotel",
    "travel_booking_collection" = "fas fa-map-marked-alt"
}

export enum BookedForTypes {
    train_bookings = "train_booked_for",
    flight_bookings = "fligth_booked_for",
    travel_info_booking = "travel_info_booked_for",
    transfer_bookings = "transfer_booked_for",
    accommodation_bookings = "accomodation_booked_for",
    flight_booking_collection = "flight_collection_booked_for",
    vt_travel_collection = "vt_travel_collect_booked_for",
    travel_booking_collection = "travel_collection_booked_for",
    transport_booking = "ht_inventory_transport"
}

export enum BookedForTranslations {
    train_booked_for = "TravelBookingForm_ClassPrintname_TrainBookedFor",
    flight_booked_for = "TravelBookingForm_ClassPrintname_FlightBookedFor",
    travel_info_booked_for = "TravelBookingForm_ClassPrintname_TravelInfoBookedFor",
    transfer_booked_for = "TravelBookingForm_ClassPrintname_TransferBookedFor",
    accomodation_booked_for = "TravelBookingForm_ClassPrintname_AccommodationBookedFor",
    flight_collection_booked_for = "TravelBookingForm_ClassPrintname_FlightCollectionBookedFor",
    vt_travel_collect_booked_for = "TravelBookingForm_ClassPrintname_VtTravelCollectBookedFor",
    travel_collection_booked_for = "TravelBookingForm_ClassPrintname_TravelCollectionBookedFor",
    ht_inventory_transport = "TravelBookingForm_ClassPrintname_HtInventoryTransport",
}

export enum BookedForToBooking {
    train_booked_for = "train_bookings",
    flight_booked_for = "flight_bookings",
    travel_info_booked_for = "travel_info_booking",
    transfer_booked_for = "transfer_bookings",
    accommodation_booked_for = "accommodation_bookings",
    ht_inventory_transport = "transport_booking",
    flight_collection_booked_for = "flight_booking_collection",
    vt_travel_collect_booked_for = "vt_travel_collection",
    travel_collection_booked_for = "travel_booking_collection"
}

export enum AddressSelectOptions {
    musician = "TravelBookingForm_Select_Musician",
    associate = "TravelBookingForm_Select_Associate",
    backoffice = "TravelBookingForm_Select_Backoffice",
    related_musicians = "TravelBookingForm_SelectRelatedMusicians",
    related_addresses = "TravelBookingForm_SelectRelatedAddresses",
}

export enum AddressCallbackFunctions {
    musician = "",
    associate = "",
    backoffice = ""
}

export type VT_Travel_Types =
    "train_bookings" | "flight_bookings" | "travel_info_booking" |
    "transfer_bookings" | "transport_booking" | "accommodation_bookings" |
    "flight_booking_collection" | "vt_travel_collection" | "travel_booking_collection";



export const BookingTypes = { ...SpecificationsIndividual, ...SpecificationsCollector };



export interface vt_travel extends more.EntityAPIResult {
    $Displayname: string;
    ClassPrintname: string;
    EL_ht_travel_address_vt_travel: Array<booked_for>;
    description: string;
    gDisp_1: string;
    ref_ev_project: ev_project;
    ref_travel_booking_collector: travel_collection;
}

export interface booked_for extends more.EntityAPIResult {
    $DisplayName: string;
    ClassPrintname: string;
    c_booked_for: string;
}

export interface travel_collection extends more.EntityAPIResult {
    $Displayname: string;
    ClassPrintname: string;
    gDisp_1: string;
}

export interface train_booking extends vehicle_transport_booking { }

export interface flight_booking extends vehicle_transport_booking { }

export interface transfer_booking extends vehicle_transport_booking {
    c_transfer_vehicle_type: string;
}


interface vehicle_transport_booking extends vt_travel {
    c_location_start: string;
    c_location_end: string;
    date_forerun: string;
    duration_forerun: number;
    date_start: string;
    duration: number;
    date_end: string;
    transportation_code: string;
    note_2: string;
}

export interface ev_project extends more.EntityAPIResult {
    $Displayname: string;
    ClassPrintname: string;
    gDisp_1: string;
}

export interface booking_collection extends vt_travel {
    EL_vt_travel_travel_booking_collector: Array<vt_travel>;
}

export interface TravelBookingListData extends more.EntityAPIResult {
    ClassPrintname: string;
    $Displayname: string;
    gDisp_1: string;
    booking_no: string;
    description: string;
    ref_ev_project: ProjectRef;
    date_start: string;
    date_end: string;
    EL_vt_travel_travel_booking_collector: [BookingCollectorRef]
}

export interface ProjectRef extends more.EntityAPIResult {
    ClassPrintname: string;
    $Displayname: string;
    gDisp_1: string;
} 

export interface BookingCollectorRef extends more.EntityAPIResult {
    ClassPrintname: string;
    $Displayname: string;
    gDisp_1: string;
}

export interface TravelBookingLoadData extends more.EntityAPIResult {
    //General
    ClassPrintname: string;
    $Displayname: string;
    gDisp_1: string;
    description: string;
    booking_no: string;
    ref_ev_project: ProjectRef;
    ref_executive_company: {
        ID: string,
        Classname: string,
        ClassPrintname: string,
        $Displayname: string,
        gDisp_1: string
    },
    ref_executive_contactperson: {
        ID: string,
        Classname: string,
        ClassPrintname: string,
        $Displayname: string,
        gDisp_1: string
    }
    EL_ht_travel_address_vt_travel?: Array<BookedForLoadData>;
    EL_ht_inventory_transport_transport_booking?: Array<InventoryLoadData>;
    ref_travel_booking_collector?: BookingCollectorRef;
    //Additional Info Widget
    ref_responsible: {
        ID: string,
        Classname: string,
        ClassPrintname: string,
        $Displayname: string,
        gDisp_1: string
    }
    note: string;
    note_internal_use: string;
    date_reminder?: string;
    //Booking Collection
    EL_vt_travel_travel_booking_collector?: Array<BookingCollectorLoadData>,
    //Individual Booking
    c_location_start?: string,
    ref_location_start?: any,
    c_location_end?: string,
    ref_location_end?: any,
    date_forerun?: string,
    duration_forerun?: number,
    date_start?: string,
    duration?: number,
    date_end?: string,
    transportation_code?: string,
    note_2?: string,
    c_transfer_vehicle_type?: string,
    ref_transfer_vehicle_type: any,
    qty_nights?: number,
    ref_alternative_time_text?: {
        ID: string,
        Classname: string,
        ClassPrintname: string
        $Displayname: string,
        description: string,
    }
}

export interface BookingCollectorLoadData extends more.EntityAPIResult {
    ClassPrintname: string
    $Displayname: string,
    description: string,
    booking_no: string
} 

export interface TravelBookingSaveData extends AdditionalFormSaveData, AdditionalInfoWidgetSaveData {
    ID: string;
    projectID: string;
    carrier: string;
    carrierCP: string;
    description: string;
    isNew: boolean;
    bookingType: VT_Travel_Types;
    bookedFor?: EntityStoreData<BookedForLoadData>;
    bookingCollectorId?: string;
    booking_no: string;
}

export interface AdditionalFormSaveData {
    locationStart?: LocationRef | string;
    locationEnd?: LocationRef | string;
    date_forerun?: string;
    duration_forerun?: number;
    date_start?: string;
    duration?: number;
    date_end?: string;
    transportation_code?: string;
    note_2?: string;
    transferVehicleRef?: VehicleRef;
    qty_nights?: number;
    alternativeTimeId?: string;
}

export interface AdditionalInfoWidgetSaveData {
    //Additional Info Widget
    responsibleId: string;
    note: string;
    note_internal_use: string;
    bookingCollectorId?: string;
    date_reminder?: string;
}

//Todo: Implement Location Ref
export interface LocationRef {
    isText: boolean;
    location: string;
}

export interface VehicleRef {
    isText: boolean;
    vehicle: string;
}

export interface InventoryLoadData extends more.EntityAPIResult {
    ClassPrintname: string;
    $Displayname: string;
    ref_transport_booking: {
        ID: string,
        Classname: string,
        ClassPrintname: string,
        $Displayname: string,
    };
    ref_vt_inventory: {
        ID: string,
        Classname: string,
        ClassPrintname: string,
        $Displayname: string,
        inventory_number: string,
        description: string
    }
}


export interface BookedForLoadData extends more.EntityAPIResult {
    ClassPrintname: string;
    $Displayname: string;
    ref_address: AddressRef;
    ref_vt_travel: {
        ID: string,
        Classname: string,
        ClassPrintname: string
        $Displayname: string,
        ref_ev_project: {
            ID: string;
            ClassPrintname: string;
            $Displayname: string;
            gDisp_1: string;
        },
        qty_nights?: number,
        ref_location_start?: {

        },
        ref_location_end?: {

        },
        transportation_code?: string,
        date_start?: string,
        date_end?: string,
        duration?: number,
        date_forerun?: string
    };
    c_booked_for: string;
    qty_persons: number;
    ref_relation_type: {
        ID: string,
        Classname: string,
        ClassPrintname: string,
        $Displayname: string,
        description: string
    };
    c_relation_type: string,
    ref_smoking_attitude: {
        ID: string,
        Classname: string,
        ClassPrintname: string,
        $Displayname: string,
        description: string
    },
    ref_travel_bookingstatus: {
        ID: string,
        Classname: string,
        ClassPrintname: string,
        $Displayname: string,
        description: string,

    },
    note: string,
    note_internal_use: string,
    booking_no: string,
    date_start_DMY?: Date,
    qty_nights?: number,
    date_end_DMY?: Date,
    date_start?: Date,
    date_end?: Date,
    ref_accommodation_roomtype?: more.EntityAPIResultExtended,
    c_accommodation_roomtype?: string,
    is_oversteered_price?: boolean,
    price_a01?: number,
    qty_A01?: number,
    price_a02?: number,
    price_breakfast?: number,
    qty_A02?: number,
    is_breakfast?: boolean,
    price_per_unit?: number,
    price_total?: number,
    accomodation_calc_mode?: string,
    ref_travel_terms_of_payment?: more.EntityAPIResultExtended,
    c_travel_terms_of_payment?: string,
    is_active?: boolean,
    is_standby?: boolean,
    room_no?: string,
    EL_accomodation_booked_for_roommate?: Array<AccommodationBookedForRoommate>,
    qty_rooms?: number;
    ref_vt_class?: Class;
}

export interface Class extends more.EntityAPIResultExtended {
    description: string;
}

export interface AddressRef extends more.EntityAPIResult {
    ClassPrintname: string;
    $Displayname: string;
    gDisp_Name_Firstname: string;
    //ref_person: {
    //    ID: string,
    //    Classname: string,
    //    ClassPrintname: string
    //    $Displayname: string,
    //    gDisp_1: string
    //}
}





